// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"cb5642f0","462":"6f581950","777":"23d463bf"}[chunkId] + ".chunk.js";
};